import { XbotTrialStatus } from '@dto/pyxbot-agent.dto';
import axios from 'axios';
import { FC, useEffect, useState } from 'react';
import { API_URL } from 'src/data/Api';
import { Label } from 'src/data/Label';

const LICENSE_URL = 'https://xormon.com/support-ng.php';

/** A quiet word on the free trial of Xbot, for an installation without any license; nothing for licensed ones. */
export const XbotTrialNote: FC<{ open: boolean }> = ({ open }) => {
  const [status, setStatus] = useState<XbotTrialStatus>();

  // asked at every opening, the days go down
  useEffect(() => {
    if (!open) return;
    let current = true;
    void axios.get<XbotTrialStatus>(`${API_URL.XBOT}/trial`).then(
      response => {
        if (current) setStatus(response.data);
      },
      () => undefined);
    return () => {
      current = false;
    };
  }, [open]);

  switch (status?.state) {
    // opening the window already reads data, which starts the trial
    case 'not_started':
    case 'active': {
      const days = status.state === 'active' ? status.daysLeft : status.days;
      return <>Free trial: {days} {days === 1 ? 'day' : 'days'} left. </>;
    }
    case 'ended':
      return <>Free trial ended, {Label.XORBOT} needs a XorMon license (<a href={LICENSE_URL} target="_blank" rel="noopener noreferrer">more</a>). </>;
    default:
      return null;
  }
};
